import { OrderRemainingHoursReportActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { successType } from '../../services/api-handlers/api-resolver';

export interface GetOrderRemainingHoursReportsAction {
    type: typeof OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS;
    payload: any;
    all?: any;
}

export function getOrderRemainingHoursReports(params: any): GetOrderRemainingHoursReportsAction {
    return {
        type: OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS,
        payload: params,
    };
}

export function clearTotal(): any {
    return {
        type: successType(OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS),
        payload: {},
        total: true,
    };
}

export function getOrderRemainingHoursReportsTotal(params: any): GetOrderRemainingHoursReportsAction {
    return {
        type: OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_TOTALS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getOrderRemainingHoursReportsCsv(params: QueryParamsAll): GetOrderRemainingHoursReportsAction {
    return {
        type: OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORTS_CSV,
        payload: params,
    };
}
export interface GetOrderRemainingHoursReportAction {
    type: typeof OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORT;
    payload: {
        id: string | number;
    };
}

export function getOrderRemainingHoursReport(id: string | number): GetOrderRemainingHoursReportAction {
    return {
        type: OrderRemainingHoursReportActions.FETCH_ORDER_REMAINING_HOURS_REPORT,
        payload: { id },
    };
}

export interface DeleteOrderRemainingHoursReportAction {
    type: typeof OrderRemainingHoursReportActions.DELETE_ORDER_REMAINING_HOURS_REPORT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteOrderRemainingHoursReport(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteOrderRemainingHoursReportAction {
    return {
        type: OrderRemainingHoursReportActions.DELETE_ORDER_REMAINING_HOURS_REPORT,
        payload: { id, onSuccess, onError },
    };
}

export type Actions =
    | GetOrderRemainingHoursReportsAction
    | GetOrderRemainingHoursReportAction
    | DeleteOrderRemainingHoursReportAction;
